import { DateTime } from 'luxon'
import { SkillType, SkillTypeDto, skillTypeFromDto } from './skillType'

declare const AreaIDSymbol: unique symbol
export type SkillID = string & { [AreaIDSymbol]: never }

export interface SkillJson {
    id: string
    name: string
    code: string
    created_at: string | null
    updated_at: string | null
    archived_at: string | null

    permissions: { can_edit: boolean }

    type?: {
        data: SkillTypeDto
    }
}

export class Skill {
    id: SkillID
    name: string
    code: string
    createdAt: DateTime | null = null
    updatedAt: DateTime | null = null
    archivedAt: DateTime | null = null

    permissions: { canEdit: boolean } = { canEdit: false }

    type: SkillType | null = null

    constructor(
        id: string,
        name: string,
        code: string,
        createdAt: DateTime | null = null,
        updatedAt: DateTime | null = null,
        archivedAt: DateTime | null = null,
        permissions: { canEdit: boolean } = { canEdit: false },
        type: SkillType | null = null,
    ) {
        this.id = id as SkillID
        this.name = name
        this.code = code
        this.createdAt = createdAt
        this.updatedAt = updatedAt
        this.archivedAt = archivedAt
        this.permissions = permissions
        this.type = type
    }

    static fromJson(json: SkillJson): Skill {
        return new Skill(
            json.id,
            json.name,
            json.code,
            json.created_at ? DateTime.fromISO(json.created_at) : null,
            json.updated_at ? DateTime.fromISO(json.updated_at) : null,
            json.archived_at ? DateTime.fromISO(json.archived_at) : null,
            { canEdit: json.permissions.can_edit },
            json.type?.data ? skillTypeFromDto(json.type?.data) : null,
        )
    }
}